// this file is automatically generated by git.revision.js script
export const versions = { revision: '703928f761' }; 
 //expose the commit hash to the window object 
//@ts-ignore 
window.rd_version = '703928f761';
